import SocialLinks from "./SocialLinks";

function SocialLinksTile() {
  return (
    <section className="bentolio-card bentolio-area-socials">
      <SocialLinks />
    </section>
  );
}

export default SocialLinksTile;
